import { Star, MapPin } from "lucide-react";

export function SpotBar({ spots, activeId, onSelect, favorites, onToggleFav }) {
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1" data-testid="spot-bar">
      {spots.map((s) => {
        const active = s.id === activeId;
        const fav = favorites.includes(s.id);
        return (
          <button
            key={s.id}
            onClick={() => onSelect(s.id)}
            data-testid={`spot-chip-${s.id}`}
            className={`group shrink-0 flex items-center gap-2 pl-3 pr-2 py-2 rounded-full border transition-colors duration-200 ${
              active
                ? "bg-sky-600 border-sky-600 text-white shadow-sm"
                : "bg-white border-slate-200 text-slate-600 hover:border-sky-300"
            }`}
          >
            <MapPin className="h-4 w-4" />
            <span className="font-head font-semibold text-sm whitespace-nowrap">{s.name}</span>
            <span
              onClick={(e) => {
                e.stopPropagation();
                onToggleFav(s.id);
              }}
              data-testid={`fav-toggle-${s.id}`}
              className="p-1 rounded-full hover:bg-black/10"
            >
              <Star
                className={`h-4 w-4 ${
                  fav ? "fill-orange-400 text-orange-400" : active ? "text-sky-200" : "text-slate-300"
                }`}
              />
            </span>
          </button>
        );
      })}
    </div>
  );
}
